/**
 * Canonical public site URL for SEO / Open Graph (absolute URLs).
 * Falls back to production origin when VITE_PUBLIC_SITE_URL is relative (e.g. '/').
 */

import { env } from '../config/env'

const DEFAULT_ORIGIN = 'https://tcgeasy.au'

export function getPublicSiteOrigin(): string {
  const raw = (env.PUBLIC_SITE_URL || '').trim()
  if (raw.startsWith('http://') || raw.startsWith('https://')) {
    return raw.replace(/\/+$/, '')
  }
  return DEFAULT_ORIGIN
}

export function absolutePublicUrl(pathnameOrPath: string): string {
  const origin = getPublicSiteOrigin()
  const path = pathnameOrPath.startsWith('/') ? pathnameOrPath : `/${pathnameOrPath}`
  return `${origin}${path}`
}
